<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      isFixed: (state) => state.header.isFixed,
    }),
  },
  mounted() {
    window.addEventListener("resize", this.resizeByScreen);
    this.resizeByScreen();

  },
  destroyed() {
    window.removeEventListener("resize", this.resizeByScreen);
  },
  methods: {
    resizeByScreen() {
      this.$store.commit(
        "SET_CLIENTWIDTH",
        document.documentElement.clientWidth
      );
    },
  },
};
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
html, body{
  font-size: 62.5%;
}
.img-splitline{
  img{
    width: 100%;
    height: auto;
    cursor: pointer;
  }
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  @media screen and (max-width: 900px) {
    font-size: 14px;
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
